<template lang="pug">
  .dashboard-container
    used-content-drawer
    search-bar
    selected-filters(v-if='showSelectedFilters')
    notification-highlight(v-if='showHighlight')
    .main-container
      ephemeride-view(v-if='isEphemerideView')
      router-view(v-else)
    remove-resource-modal(v-if='showRemoveResourceModal' :text='$t("removeResource.textAll")')
    add-resource-modal(v-if='showAddResourceModal')
    onboarding-modal(v-if='showOnboardingModal')
</template>

<script>
import { mapActions, mapState } from 'vuex'

import SearchBar from '@/components/NewFeed/SearchBar'
import RemoveResourceModal from '@/components/RemoveResourceModal'
import AddResourceModal from '@/components/Resource/AddResource'
import OnboardingModal from '@/components/Modals/OnboardingModal'
import NotificationHighlight from '@/components/Notifications/NotificationHighlight'
import UsedContentDrawer from '../components/UsedContent/UsedContentDrawer'
import userRole from '../mixins/userRole'
import { routes } from '../router'
import SelectedFilters from '../components/NewFeed/SelectedFilters'
import EphemerideView from '../components/NewFeed/Ephemeride'

export default {
  name: 'Feed',
  components: {
    EphemerideView,
    SelectedFilters,
    UsedContentDrawer,
    NotificationHighlight,
    SearchBar,
    RemoveResourceModal,
    OnboardingModal,
    AddResourceModal
  },
  mixins: [userRole],
  watch: {
    selectedFilters() {
      if (!this.hasSelectedFilters) this.$router.push({ name: routes.feedInitial })
    }
  },
  computed: {
    ...mapState({
      showRemoveResourceModal: state => state.behavior.removeResourceModal.show,
      showAddResourceModal: state => state.behavior.addResourceModal.show,
      showOnboardingModal: state => state.behavior.onboardingModal.show,
      showAdvancedFilters: state => state.behavior.advancedFilters.show,
      navigationTutorialActive: state => state.userInfo.userInfo.navigationTutorialActive
    }),
    showHighlight() {
      return this.$route.name === routes.feedInitial
    },
    isEphemerideView() {
      return this.$route.query.ephemerideId && this.$route.query.ephemerideLocale
    },
    showSelectedFilters() {
      return this.hasSelectedFilters && this.$route.name !== routes.seeMore
    },
    selectedFilters() {
      return this.$route.query
    },
    hasSelectedFilters() {
      return Object.keys(this.selectedFilters).length
    },
    seeMoreView() {
      return this.$route.name === routes.seeMore
    }
  },
  async created() {
    await this.hydrateHighlightNotification()
    if (this.navigationTutorialActive) this.showElement({ element: 'onboardingModal' })
  },
  methods: {
    ...mapActions([
      'hydrateHighlightNotification',
      'hideElement',
      'showElement'
    ])
  }
}
</script>

<style lang="scss" scoped>
@import '../scss/variables/colors';
@import '../scss/variables/sizes';

.dashboard-container {
  background-color: $lighter-gray;
  min-height: calc(100vh - #{$footer-height});
}

.educational-program {
  height: 400px;
}

.category {
  width: 100%;

  &:last-child {
    margin-bottom: 60px;
  }
}

.empty-resources {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 55px;
  max-width: 657px;
  text-align: center;
}

.message-short {
  max-width: 305px;
  text-align: center;
}

.empty-icon {
  height: 205px;
}

.view-container {
  display: flex;
  justify-content: center;
  width: 100%;
  z-index: 1;
}

.gray-bg {
  background-color: $black-translusent;
  height: 100%;
  position: absolute;
  width: 100%;
}
</style>
